import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { CurrencyRepositoryBase } from '@skylab-shared/business';
export { CurrencyRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(CurrencyRepositoryBase)
export class CurrencyRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) { }
}
